import { Box, Flex, Image, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { TopDrop } from '../../types'
import FlipCard from '../FlipCard'
import DropContainer from './DropContainer'
import DropTitle from './DropTitle'
import Front from './Front'
import fireIcon from '../../assets/fire.gif'
import React, { useEffect, useMemo, useRef } from 'react'
import Back from './Back'
import gsap from 'gsap'
const WowDrops = React.memo(
  ({
    wowDataValues,
    TOTAL_WOW_ITEMS,
    wowDropItemWidth,
    isMobile,
    iswowOnHover,
    setIswowOnHover,
    timelineRef,
  }: {
    wowDataValues: {
      skins: TopDrop[]
      newEventsCount: number
    }
    TOTAL_WOW_ITEMS: number
    wowDropItemWidth: number
    isMobile: boolean
    iswowOnHover: boolean
    setIswowOnHover: (iswowOnHover: boolean) => void
    timelineRef: any
  }) => {
    // ref 绑定动画容器
    const wowAniContainerRef = useRef<HTMLDivElement>(null)
    const wowDropWidth = useMemo(() => {
      if (wowDropItemWidth) {
        return `calc(${wowDropItemWidth + 1}px * 3)`
      }
    }, [wowDropItemWidth])
    const dropTimelineRef = useRef<gsap.core.Timeline | null>(null)
    const savedTranslateProgressRef = useRef<number>(0)

    // wow 动画
    useEffect(() => {
      if (!wowDataValues.newEventsCount) return
      const newEventsLength = wowDataValues.newEventsCount
      if (newEventsLength === 0) return
      const container = wowAniContainerRef.current
      const ctx = gsap.context(() => {
        if (container) {
          // 1. 平移动画时间线
          timelineRef.current = gsap.timeline().fromTo(
            container,
            { translateX: -(wowDropItemWidth + 1) * wowDataValues.newEventsCount },
            {
              translateX: 0,
              duration: 0.8,
              ease: 'power2.out',
              onComplete: () => {
                gsap.set(container, { clearProps: 'translateX' })
              },
            },
          )
          // 2. 掉落动画时间线
          const boxesToAdd = gsap.utils
            .toArray<HTMLElement>('.wow-item', container)
            .slice(0, newEventsLength)
          dropTimelineRef.current = gsap.timeline().fromTo(
            boxesToAdd,
            { y: -300 },
            {
              y: 0,
              duration: 0.3,
              stagger: -0.08,
              ease: 'power2.out',
              onComplete: () => {
                gsap.set(boxesToAdd, { clearProps: 'y' })
              },
            },
          )
        }
      }, container ?? undefined)
      return () => {
        ctx.revert()
        timelineRef.current = null
        dropTimelineRef.current = null
        gsap.set(container, { translateX: 0 })
        gsap.set('.wow-item', { y: 0, clearProps: 'all' })
      }
    }, [wowDataValues.skins, wowDataValues.newEventsCount])

    // hover控制wow动画
    useEffect(() => {
      const translateTl = timelineRef.current
      if (iswowOnHover) {
        if (translateTl) {
          translateTl.pause()
          savedTranslateProgressRef.current = translateTl.progress()
        }
      } else {
        requestAnimationFrame(() => {
          if (!translateTl) return
          if (translateTl.progress() === 1) return
          translateTl.progress(savedTranslateProgressRef.current || 0)
          translateTl.play()
        })
      }
    }, [iswowOnHover])

    return (
      <>
        {wowDataValues.skins.length >= TOTAL_WOW_ITEMS && (
          <Box width={wowDropWidth} minW={wowDropWidth}>
            <DropTitle>
              <Image
                src={fireIcon}
                position={'absolute'}
                width={'29px'}
                objectFit={'cover'}
                left={0}
                top={0}
                transform={'translate(-25%, -35%)'}
              />
              <Text
                pl={2}
                fontSize={['xs', 'sm']}
                background={'linear-gradient(90deg, #FFE03F 0%, #FF7918 100%)'}
                backgroundClip={'text'}
                backgroundSize={'200% auto'}
                color={'transparent'}
                width={'fit-content'}
                textTransform={'uppercase'}
                whiteSpace={'nowrap'}
              >
                <Trans>top drops</Trans>
              </Text>
            </DropTitle>
            <DropContainer>
              <Flex
                onMouseEnter={() => setIswowOnHover(true)}
                onMouseLeave={() => setIswowOnHover(false)}
                position={'absolute'}
                top={0}
                left={0}
                right={0}
                bottom={0}
                overflow={'hidden'}
              >
                <Flex className="wow-ani-container" gap={'1px'} ref={wowAniContainerRef}>
                  {wowDataValues.skins?.map((_: TopDrop, index: number) => {
                    return (
                      <FlipCard
                        key={`wow-${_.instanceId}`}
                        isLoaded={true}
                        front={<Front {..._} isMobile={isMobile} />}
                        back={<Back {..._} />}
                        containerStyle={{
                          width: wowDropItemWidth,
                          minW: 0,
                          flex: 'none',
                          className: 'wow-item',
                        }}
                      />
                    )
                  })}
                </Flex>
              </Flex>
            </DropContainer>
          </Box>
        )}
      </>
    )
  },
)

export default WowDrops
